/**
 *
 * @param {string} input
 * @return {string}
 */
export default function toSnakeCase(input) {
  if (typeof input !== 'string') return input;

  return input
    .replace(/\W+/g, ' ')
    .split(/ |\B(?=[A-Z])/)
    .map(word => word.toLowerCase())
    .join('_');
}
